
<p class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
<app-manage-merchants

(onFormSubmit)="editMerchant($event)" [title]="'edit'">

</app-manage-merchants>
